import { addDaysToDateInput } from './dateRange';
import { toPlotlyLocal } from './plotlyLocalTime';

/**
 * FS-723: the raw charts (scatter, temperature) can run past the last
 * processed day, up to today. Those later days have readings but no daily
 * analysis yet; this is how both charts say so — a shaded band over those
 * days, a small "not yet analysed" label at its left edge, and a caption
 * naming both ends.
 *
 * Both band edges are UTC midnights (the day boundary the daily analysis and
 * the readings lambdas use), drawn on the chart axis's own zone via
 * `toPlotlyLocal`, like the readings themselves.
 */
export function unanalysedDaysOverlay(
  endDate: string,
  analysedThrough: string | undefined,
  timeZone: string | null,
) {
  // `caption` is null when every plotted day is analysed.
  if (!analysedThrough || !(endDate > analysedThrough)) {
    return { shapes: [], annotations: [], caption: null };
  }
  const bandStart = toPlotlyLocal(`${addDaysToDateInput(analysedThrough, 1)}T00:00:00Z`, timeZone);
  const bandEnd = toPlotlyLocal(`${addDaysToDateInput(endDate, 1)}T00:00:00Z`, timeZone);
  return {
    shapes: [{
      type: 'rect' as const,
      xref: 'x' as const,
      yref: 'paper' as const,
      x0: bandStart,
      x1: bandEnd,
      y0: 0,
      y1: 1,
      fillcolor: 'rgba(156, 163, 175, 0.18)',
      line: { width: 0 },
      layer: 'below' as const,
    }],
    annotations: [{
      xref: 'x' as const,
      yref: 'paper' as const,
      x: bandStart,
      y: 1,
      xanchor: 'left' as const,
      yanchor: 'bottom' as const,
      text: 'not yet analysed',
      showarrow: false,
      font: { size: 10, color: '#6b7280' },
    }],
    caption: `Readings through ${endDate}; daily analysis through ${analysedThrough}.`
      + ' The shaded days are raw readings the daily charts do not cover yet.',
  };
}
